module.exports = __webpack_public_path__ + "img/245-Spliceosomes-3jb9.2f04aa9b.jpg";